import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorServiceNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IServiceModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IServiceFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useServiceHookNae(id: number) : IServiceModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorServiceNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Service.schema,
        fields: IServiceFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
